export default __webpack_public_path__ + "static/media/keyboard_arrow_down.82719b5d.svg";